<!-- eslint-disable vue/require-v-for-key -->
<template>
  <div>
    <v-row>
      <v-col class="mt-3 pt-2">
        <label class="text-h6 text-weight-black">Estoque</label>
      </v-col>
    </v-row>
    <v-row>
      <v-col class="mt-0 pt-0">
        <div
          v-for="size in sizes"
          style="
            width: 50px;
            float: left;
            padding-right: 5px;
            border: 1px solid #000;
          "
          class="py-0"
        >
          <label style="padding-left: 15px" class="font-weight-bold">{{
            size
          }}</label>
        </div>
        <div
          style="
            width: 60px;
            float: left;
            padding-right: 5px;
            border: 1px solid #000;
          "
          class="py-0"
        >
          <label style="padding-left: 15px" class="font-weight-bold">
            Total
          </label>
        </div>
      </v-col>
    </v-row>
    <v-row class="mt-0">
      <v-col class="mt-0 pt-0">
        <div
          v-for="size in stock"
          style="
            width: 50px;
            float: left;
            padding-right: 5px;
            border: 1px solid #000;
          "
          class="py-0"
        >
          <label style="padding-left: 15px" class="">{{ size }}</label>
        </div>
        <div
          style="
            width: 60px;
            float: left;
            padding-right: 5px;
            border: 1px solid #000;
          "
          class="py-0"
        >
          <label style="padding-left: 15px" class="">
            {{ stock.reduce((prev, next) => prev + next, 0) }}
          </label>
        </div>
      </v-col>
    </v-row>
  </div>
</template>

<script>
export default {
  props: {
    sizes: {
      type: Array,
      default: () => [],
    },
    stock: {
      type: Array,
      default: () => [],
    },
  },
};
</script>
